<div class="loading-message">
  <img class="logo" src="assets/small-logo-dark.svg" [ngStyle]="getLogoStyle" alt="loading logo" />
  <span class="loading"></span>
</div>
